import * as THREE from 'three';

export type AABB = { min: THREE.Vector3; max: THREE.Vector3 };

export function resolveAABBXZ(moving: AABB, staticBox: AABB): { x: number; z: number } | null {
  if (
    moving.max.x < staticBox.min.x ||
    moving.min.x > staticBox.max.x ||
    moving.max.z < staticBox.min.z ||
    moving.min.z > staticBox.max.z
  ) {
    return null;
  }

  const dx1 = staticBox.max.x - moving.min.x;
  const dx2 = moving.max.x - staticBox.min.x;
  const dz1 = staticBox.max.z - moving.min.z;
  const dz2 = moving.max.z - staticBox.min.z;

  const pushX = Math.min(dx1, dx2);
  const pushZ = Math.min(dz1, dz2);

  if (pushX < pushZ) {
    return { x: dx1 < dx2 ? pushX : -pushX, z: 0 };
  }

  return { x: 0, z: dz1 < dz2 ? pushZ : -pushZ };
}
